"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return mapDefaultDisplayValue;
    }
});
const _nocodbsdk = require("nocodb-sdk");
function mapDefaultDisplayValue(columnsArr) {
    if (!columnsArr.some((column)=>column.pv)) {
        const pkIndex = columnsArr.findIndex((column)=>column.pk);
        // find first supported display value column which is not system column
        const displayValueColumn = columnsArr.find((column)=>(0, _nocodbsdk.isSupportedDisplayValueColumn)(column) && !column.system && !(0, _nocodbsdk.isCreatedOrLastModifiedTimeCol)(column));
        if (displayValueColumn) {
            displayValueColumn.pv = true;
            return displayValueColumn;
        }
        // if PK is at the end of table
        if (pkIndex === columnsArr.length - 1) {
            if (pkIndex > 0) {
                columnsArr[pkIndex - 1].pv = true;
                return columnsArr[pkIndex - 1];
            } else if (columnsArr.length > 0) {
                columnsArr[0].pv = true;
                return columnsArr[0];
            }
        // pk is not at the end of table
        } else if (pkIndex > -1) {
            columnsArr[pkIndex + 1].pv = true;
            return columnsArr[pkIndex + 1];
        //  no pk at all
        } else {
            if (columnsArr.length > 0) {
                columnsArr[0].pv = true;
                return columnsArr[0];
            }
        }
    }
}
